import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

/** Measured minus total volume; `null` when the measured volume is unknown, 0 without a total volume. */
export const volumeDifference = (tj: Partial<TherapyJobV2>): number | null => {
  const totalVolume = tj?.totalVolumeEdited || tj?.totalVolumePrescribed;
  const injectedVolume = tj?.therapyJobProgress?.injectedVolume ?? null;

  if (!totalVolume) {
    return 0;
  }

  if (injectedVolume === null) {
    return null;
  }

  return injectedVolume - totalVolume;
};
